/**
 * This is largely adapted from: https://github.com/wbkd/react-flow/blob/main/packages/controls/src/Controls.tsx
 * which is unforunately not very configurable to allow for custom components / interactivity for each control
 */

import { Stack, StackProps } from '@mui/material';
import { Panel } from '@xyflow/react';
import { ComponentProps, FC, PropsWithChildren } from 'react';

import { CONTROLS_ID } from './constants';

type PanelProps = ComponentProps<typeof Panel>;

export interface ControlProps extends Partial<PanelProps> {
  alignItems?: StackProps['alignItems'];
}

export const Controls: FC<PropsWithChildren<ControlProps>> = ({
  children,
  position = 'top-right',
  id = CONTROLS_ID,
  alignItems = 'center',
  ...rest
}) => {
  return (
    <Panel id={id} position={position} {...rest}>
      <Stack flexDirection="row" gap={1} alignItems={alignItems}>
        {children}
      </Stack>
    </Panel>
  );
};
